import Script from 'next/script';

export function GtagScript({ gtagId }: { gtagId: string }) {
  return <Script src={`https://stt.nimbusweb.me/gtag/js?id=${gtagId}`} async />;
}

export function GtmScript({ gtagId, gtmId }: { gtmId: string; gtagId: string }) {
  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', '${gtagId}', {
        page_path: window.location.pathname,
      });
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
          'https://stt.nimbusweb.me/gtlytics.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${gtmId}');
    `,
      }}
    />
  );
}

export const TagManager = ({ gtagId, gtmId }: { gtagId: string; gtmId: string }) => {
  return (
    <>
      <GtagScript gtagId={gtagId} />
      <GtmScript gtagId={gtagId} gtmId={gtmId} />
    </>
  );
};
